import t from 'tcomb';
import Validation from './Validation';
import Rule from './Rule';
import Int from './Int';
import Natural  from './Natural';
import Str_Format from './Str_Format';
import { keys } from 'lodash';

// Haskell return
var unit = function(x) {
  return new Validation(
    { x: x,
     rule: null
    }
  );
};

// Haskell >>=
var bind = function(validation, f) {
  t.assert(Validation.is(validation));
  t.assert(t.Func.is(f));

  if (validation.x === null) {
    return validation;
  }
  else if (validation.rule) {
    return validation;
  }
  return f(validation.x);
};

var required = function(b) {
  t.assert(t.Bool.is(b));
  return function(x) {
    if (t.Str.is(x)) {
      x = x.trim();
      if (x.length === 0) {
        x = null;
      }
    }
    if (b && x === null) {
      return new Validation({x: x, rule: new Rule({name: 'required'})});
    }
    return unit(x);
  };
};

var max_length = function(length) {
  t.assert(Natural.is(length));
  return function(x) {
    if (x.length > length) {
      return new Validation({x: x, rule: new Rule({name: "max_length", args: [length]})});
    }
    return unit(x);
  };
};

var min_length = function(length) {
  t.assert(Natural.is(length));
  return function(x) {
    if (x.length < length) {
      return new Validation({x: x, rule: new Rule({name: "min_length", args: [length]})});
    }
    return unit(x);
  };
};

var format = function(sf) {
  t.assert(Str_Format.is(sf));
  return function(x) {
    var p = Str_Format.formats[sf];
    if (!p(x)) {
      return new Validation({x: x, rule: new Rule({name: "format", args: [sf]})});
    }
    return unit(x);
  };
};

var any_of = function(values, is_case_insensitive) {
  t.assert(t.Arr.is(values));
  return function(x) {
    var lower = String(x).toLowerCase();
    if (values.every(function(value) {
        return is_case_insensitive ?
          String(value).toLowerCase() !== lower :
          value !== x;
      })) {
      return new Validation({x: x, rule: new Rule({name: "any", args: [values]})});
    }
    return unit(x);
  };
};

var is_num = function(number_format) {
  //t.assert(Number_Format.is(number_format));
  return function(x) {
    x = number_format.parse_number(x);
    if (x === null || !isFinite(x)) {
      return new Validation({x: x, rule: new Rule({name: "number"})});
    }
    return unit(x);
  };
};

var max = function(i) {
  t.assert(t.Num.is(i));
  return function(x) {
    if (x > i) {
      return new Validation({x: x, rule: new Rule({name: "max", args: [i]})});
    }
    return unit(x);
  };
};

var min = function(i) {
  t.assert(t.Num.is(i));
  return function(x) {
    if (x < i) {
      return new Validation({x: x, rule: new Rule({name: "min", args: [i]})});
    }
    return unit(x);
  };
};

function is_integer(n) {
  return n === parseInt(n, 10);
}

var is_int = function(x) {
  if (!is_integer(x)) {
    return new Validation({x: x, rule: new Rule({name: "integer"})});

  }
  return unit(x);
};

var bool = function(x) {
  if (!t.Bool.is(x)) {
    return new Validation({x: x, rule: new Rule({name: "boolean"})});
  }
  return unit(x);
};

var array = function(x) {
  if (!t.Arr.is(x)) {
    return new Validation({x: x, rule: new Rule({name: "array"})});
  }
  return unit(x);
};

var min_items = function(min) {
  //t.assert(Natural.is(min));
  return function(x) {
    if (x.length < min) {
      return new Validation({x: x, rule: new Rule({name: "min_items", args: [min]})});
    }
    return unit(x);
  };
};

var is_ranking = function() {
  return function(x) {
    var answer = {}
    for (var i = 0; i < x.length; i++) {
      if (!answer[x[i][1]]) {
        answer[x[i][1]] = 1
      }
    }
    if (x.length !== keys(answer).length) {
      return new Validation({x: x, rule: new Rule({name: "is_ranking"})});
    }
    return unit(x);
  };
};


function days_per_month(yyyy) {
  return function(MM) {
    return {
      0: 31,
      1: yyyy % 4 === 0 ? 29 : 28, // handle leap year
      2: 31,
      3: 30,
      4: 31,
      5: 30,
      6: 31,
      7: 31,
      8: 30,
      9: 31,
      10: 30,
      11: 31
    }
    [MM - 1];
  };
}
// parti di una data
var Year = Int;
var Month = t.subtype(Natural, function(x) {
  return x >= 1 && x <= 12;
});
var Day = t.subtype(Natural, function(x) {
  return x >= 1 && x <= 31;
});
var Hour = t.subtype(Natural, function(x) {
  return x >= 0 && x <= 23;
});
var Minute = t.subtype(Natural, function(x) {
  return x >= 0 && x <= 59;
});
var Short_Date = t.subtype(t.tuple([Year, Month, Day]), function(x) {
  return x[2] <= days_per_month(x[0])(x[1]);
});
var Accurate_Date = t.subtype(t.tuple([Year, Month, Day, Hour, Minute]), function(x) {
  return x[2] <= days_per_month(x[0])(x[1]);
});

var date = function(required) {
  t.assert(t.Bool.is(required));
  return function(x) {
    t.assert(t.list(t.Str).is(x));
    if (x.every(function(y) {
        return y === '';
      }) && !required) {
      return unit(null);
    }
    x = x.map(function(y) { // converto le parti in interi
      return parseInt(y, 10);
    });
    if (x.length === 5) { // la data è accurata
      if (!Accurate_Date.is(x)) { // controllo che sia una data valida
        return new Validation({x: x, rule: new Rule({name: "date"})});
      }
      x[1] = x[1] - 1; // in JavaScript i mesi sono zero based
      return unit(new Date(x[0], x[1], x[2], x[3], x[4], 0).getTime());
    }
    else {
      if (!Short_Date.is(x)) { // controllo che sia una data valida
        return new Validation({x: x, rule: new Rule({name: "date"})});
      }
      x[1] = x[1] - 1; // in JavaScript i mesi sono zero based
      return unit(new Date(x[0], x[1], x[2]).getTime());
    }
  };
};

var pipe = function(x: t.String | t.Array | t.Boolean, actions) {
  return actions.reduce(bind, unit(x));
};

module.exports = {
  unit: unit,
  bind: bind,
  pipe: pipe,
  required: required,
  max_length: max_length,
  min_length: min_length,
  format: format,
  any: any_of,
  is_number: is_num,
  is_integer: is_int,
  max: max,
  min: min,
  bool: bool,
  array: array,
  min_items: min_items,
  is_ranking: is_ranking,
  date: date
};



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Validation_Monad.js
 **/